import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_TICKETNOTIFICATION } from "../../../utils/constants";
import { NotificationInterface } from "../../../models/notification";
import notificationService from "../../../services/notificationService";

interface UpdateNotificationContext {
  previousNotification: NotificationInterface[];
}

const useUpdateAllTicketNotif = () => {
  const queryClient = useQueryClient();

  return useMutation<
    NotificationInterface[],
    Error,
    NotificationInterface[],
    UpdateNotificationContext
  >({
    mutationFn: async () => {
      return notificationService.MarkAllNotificationRead();
    },

    onMutate: async () => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_TICKETNOTIFICATION],
      });

      const previousNotification =
        queryClient.getQueryData<NotificationInterface[]>([
          CACHE_KEY_TICKETNOTIFICATION,
        ]) || [];

      queryClient.setQueryData<NotificationInterface[]>(
        [CACHE_KEY_TICKETNOTIFICATION],
        () => []
      );

      return { previousNotification };
    },

    onSuccess: () => {
      queryClient.setQueryData<NotificationInterface[]>(
        [CACHE_KEY_TICKETNOTIFICATION],
        () => []
      );
    },

    onError: (error, updatedNotification, context) => {
      if (!context) return;

      queryClient.setQueryData<NotificationInterface[]>(
        [CACHE_KEY_TICKETNOTIFICATION],
        context.previousNotification
      );
    },
  });
};

export default useUpdateAllTicketNotif;
